import { Component, ComponentChild, h } from 'preact';
import { CmsImageData, Properties } from '../../common';
import { BookingState, connectStore } from '../../store';
import { withStyles, WithStyles } from '../../style';
import BackgroundImage from './BackgroundImage/BackgroundImage';
import * as styles from './BackgroundImage/BackgroundImage.scss';

export interface RootContainerProps extends Properties {
  embedded: boolean;
  campaignImage?: CmsImageData;
}
interface StoreProps {
  defaultImage?: CmsImageData;
  destinationImage?: CmsImageData;
  enableCompactWidget: boolean;
}
type EffectiveProps = RootContainerProps & WithStyles & StoreProps;

const mapStateToProps = ({ selection, ux, enableCompactWidget }: BookingState): StoreProps => ({
  defaultImage: ux?.i18n?.localizations?.backgroundImage,
  destinationImage: selection?.locations[selection.activeLocationIndex]?.destination?.picture,
  enableCompactWidget,
});

@withStyles(styles)
@connectStore({ mapStateToProps })
export default class RootContainer extends Component<RootContainerProps> {
  render({
    embedded,
    campaignImage,
    defaultImage,
    destinationImage,
    children,
    enableCompactWidget,
    tx,
    ...attr
  }: EffectiveProps): ComponentChild {
    return (
      <div
        {...attr}
        class={tx(this.props.class, { heroImage: enableCompactWidget && !embedded }, 'relative', 'notranslate')}
      >
        {!embedded && <BackgroundImage src={destinationImage || campaignImage || defaultImage} />}
        {children}
      </div>
    );
  }
}
